module.exports = __webpack_public_path__ + "static/media/AP_ES_Z1.ac8a7128.png";